import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getControlloResidenzaAzienda(cap,apiPath,init) {
    return (dispatch) => {
        API.getAxios(apiPath).get(`/anagrafica/cap/${cap}/controllo`)
        .then(response => {
            if(init){
                dispatch({ type: actionTypes.INIT_CONTROLLO_RESIDENZA_AZIENDA, payload: response.data});
            }else{
                dispatch({ type: actionTypes.CONTROLLO_RESIDENZA_AZIENDA, payload: response.data});
            }
            dispatch({ type: actionTypes.LOADING_RESIDENZA_AZIENDA_FALSE });
        })
        .catch(errore => {
            dispatch({ type: actionTypes.ERROR_CONTROLLO_CAP_AZIENDA, payload: errore.response.data});
            if(errore.response.data.errorCode === 'generico'){
                message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
            }
            dispatch({ type: actionTypes.LOADING_RESIDENZA_AZIENDA_FALSE });
        })
    };
}

export default getControlloResidenzaAzienda;